module.exports = __webpack_public_path__ + "img/rlzyhy_banner03_img.53d10bed.png";